'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const SortExtensions=require('../../../../../../dist-es6/client/extensions/sortExtensions');
const BaseController=require('../../../../../../dist-es6/client/angularCommon/baseController');
const BaseControllerBackedDirective=require('../../../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

FleetListDirective=function(_BaseControllerBacked){_inherits(FleetListDirective,_BaseControllerBacked);function FleetListDirective(){_classCallCheck(this,FleetListDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(FleetListDirective,[{key:'templateUrl',get:function()
{
return'/templates/features/fleetInsight/components/fatigueTrends/fleetListView';
}},{key:'controller',get:function()

{
return FleetListController;
}}]);return FleetListDirective}(BaseControllerBackedDirective);let


FleetListController=function(_BaseController){_inherits(FleetListController,_BaseController);_createClass(FleetListController,null,[{key:'$inject',get:function()
{
return['fatigueTrendsDataService','userService','uncaughtErrorHandler'];
}}]);

function FleetListController(fatigueTrendsDataService,userService,uncaughtErrorHandler){_classCallCheck(this,FleetListController);var _this2=_possibleConstructorReturn(this,
_BaseController.call(this,uncaughtErrorHandler));
_this2._fatigueTrendsDataService=fatigueTrendsDataService;

_this2._sortByDescendingAvgFatigueOnDuty=SortExtensions(_this2._sortByAverageFatigueOnDuty).invert();

_this2.columnDefinitions=[{
label:'Average',
isInitiallyActive:!0,
defaultAscending:!1,
orderBy:[_this2._sortByAverageFatigueOnDuty],
finalSort:['name'],
columnClass:'average-fatigue-column'},
{
label:'Name',
defaultAscending:!0,
orderBy:['name'],
finalSort:[_this2._sortByDescendingAvgFatigueOnDuty],
columnClass:'name-column'},

{
label:'Duty Hours',
defaultAscending:!1,
orderBy:['dutyHours'],
finalSort:[_this2._sortByDescendingAvgFatigueOnDuty,'name'],
columnClass:'duty-hours-column'},

{
label:'Peak',
defaultAscending:!1,
orderBy:[_this2._sortByMaxFatigueOnDuty],
finalSort:[_this2._sortByDescendingAvgFatigueOnDuty,'name'],
columnClass:'peak-fatigue-column'},
{

columnClass:'filler-column'}];return _this2;

}FleetListController.prototype.

_sortByMaxFatigueOnDuty=function _sortByMaxFatigueOnDuty(row){
return _.exists(row.maxFatigueOnDuty)?Math.floor(row.maxFatigueOnDuty):Number.NEGATIVE_INFINITY;
};FleetListController.prototype.

_sortByAverageFatigueOnDuty=function _sortByAverageFatigueOnDuty(row){
return _.exists(row.averageFatigueOnDuty)?Math.floor(row.averageFatigueOnDuty):Number.NEGATIVE_INFINITY;
};_createClass(FleetListController,[{key:'personRowModels',get:function()

{

return _.get(this._fatigueTrendsDataService,'selectedGroupData.aggregatePersons')||[];
}}]);return FleetListController}(BaseController);


module.exports=FleetListDirective;
//# sourceMappingURL=fleetListDirective.js.map
